/**
 * 몬스터 원거리 투사체. 플레이어에 맞거나 발판/수명에 닿으면 사라진다.
 */

import Phaser from 'phaser';
import { ANIM } from '../assets/animations';
import type { StatusInflict } from '../data/monsters';
import { DEPTH } from '../game/depth';

export class MonsterShot extends Phaser.Physics.Arcade.Sprite {
  readonly accuracy: number;
  readonly attack: number;
  readonly inflict?: StatusInflict;
  private life = 2200;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    dir: 1 | -1,
    speed: number,
    accuracy: number,
    attack: number,
    inflict?: StatusInflict,
  ) {
    super(scene, x, y, 'fx-spore', 0);
    this.accuracy = accuracy;
    this.attack = attack;
    this.inflict = inflict;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setDepth(DEPTH.effect).setFlipX(dir < 0);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setAllowGravity(false);
    body.setSize(10, 10, true);
    body.setVelocityX(dir * speed);
    body.setVelocityY(-18);
    if (this.anims.exists(ANIM.spore)) this.play(ANIM.spore, true);
  }

  override preUpdate(time: number, delta: number): void {
    super.preUpdate(time, delta);
    this.life -= delta;
    if (this.life <= 0 || !this.active) this.destroy();
  }
}
